import { HttpHandler, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';

import { v4 as uuidv4 } from 'uuid';

import { environment } from '@env';

import { CoreAuthServiceBase, WebHttpUrlEncodingCodec } from 'pn-core-code';

@Injectable()
export class AuthService extends CoreAuthServiceBase {

  tempLogin(username: string, password: string): Observable<any> {
    if (username === 'sysadmin' && password === 'P@ssw0rd1!') {
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next("Login Success");

          this.handleLoginSuccess({ access_token: 'access_token', refresh_token: 'refresh_token', expires_in: undefined, scope: undefined });

          subscriber.complete();
        }, 1000);
      });;
    } else if (username === 'executivewpn' && password === 'P@ssw0rd1!') {
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next("Login Success");

          this.handleLoginSuccess({ access_token: 'access_token', refresh_token: 'refresh_token', expires_in: undefined, scope: undefined });

          subscriber.complete();
        }, 1000);
      });;
    } else if (username === 'centralwpn' && password === 'P@ssw0rd1!') {
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next("Login Success");

          this.handleLoginSuccess({ access_token: 'access_token', refresh_token: 'refresh_token', expires_in: undefined, scope: undefined });

          subscriber.complete();
        }, 1000);
      });;
    } else if (username === 'employeewpn' && password === 'P@ssw0rd1!') {
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next("Login Success");

          this.handleLoginSuccess({ access_token: 'access_token', refresh_token: 'refresh_token', expires_in: undefined, scope: undefined });

          subscriber.complete();
        }, 1000);
      });;
    } else if (username === 'executivefranchise' && password === 'P@ssw0rd1!') {
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next("Login Success");

          this.handleLoginSuccess({ access_token: 'access_token', refresh_token: 'refresh_token', expires_in: undefined, scope: undefined });

          subscriber.complete();
        }, 1000);
      });;
    }
    else if (username === 'employeefranchise' && password === 'P@ssw0rd1!') {
      return new Observable((subscriber) => {
        setTimeout(() => {
          subscriber.next("Login Success");

          this.handleLoginSuccess({ access_token: 'access_token', refresh_token: 'refresh_token', expires_in: undefined, scope: undefined });

          subscriber.complete();
        }, 1000);
      });;
    }

    throw throwError(() => new Error('Login Fail'));
  }

  override  handleWithJwt(response: any) {
    console.log('response', response);
    const [claims, claimsJson] = this.decodeIdToken(response.accessToken);
    this.storage.setItem('claims_obj', claimsJson);
    response.expires_in = response.expires_in || claims.exp;
    return response.expires_in || claims.exp;
  }

  override handleLoginSuccess(response: any) {
    console.log('handleLogin Success response', response);
    this.storeAccessToken(response.accessToken, response.refresh_token, response.expires_in, response.scope);
    this.setAdditionalAuthData(response);
    this.setAuthorize();
  }


  override logout() {
    console.log('logiut');
    this.storage.removeItem('user');
    this.storage.removeItem('focus_user_group');
    super.logout();
    this.router.navigate([this.localize.translateRoute('/auth/login')], { replaceUrl: true });
  }


  // tokenExpired() {
  //   this.removeAdditionalAuthData();
  //   this.router.navigate([this.localize.translateRoute('/auth/login')], { replaceUrl: true });
  // }

}
